





















import { Component, Prop } from "vue-property-decorator";
import AppVue from "@/AppVue.vue";
import { images } from "@/core/constants";

@Component
export default class ProgramOverviewImageDialogCpt extends AppVue {
  @Prop({ default: false }) visible: boolean;

  get programOverviewImgUrl() {
    return images.programOverview;
  }

  close() {
    this.$emit("close");
  }
}
